import modalElement from "../../modals/modal";
import ModalBase from "../../abstracts/modalBase";
import HistorySlideText from "../../textSlider/historySlide/historyTextSlide";

export default class ModalHistory extends ModalBase {
    private static idModal = "modal-history";
    private static dimension = "modal-large";
    protected static modalTitle = "História da Assembleia";
    private static elementToRender = modalElement(
        ModalHistory.idModal,
        ModalHistory.dimension,
        ModalHistory.modalTitle
    );
    
    constructor(protected container){
        super(
            ModalHistory.modalTitle,
            container,
            ModalHistory.idModal,
            ModalHistory.elementToRender
        );
    }

    public loadBody(cb:()=>void){
        new HistorySlideText(this.modalBody).renderSlide();
    }
}